import { axios } from '@/services/axios';

export default async function createService(params) {
    const companyId = params.companyId;
    return axios
        .post(`/Service/${params.serviceType}/Magic/${companyId}`, {
            name: params.name,
            companyId,
        })
        .then((res) => res)
        .catch((e) => e);
}
